/* eslint-disable no-undef */
import { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { Stack } from '@mui/material';
import Chip from '@mui/material/Chip';

const MapDeleteButtonOverlay = ({ map, position, onClick, label = 'Delete', color = 'error', getPixelPosition }) => {
    const instance = useRef();

    useEffect(() => {
        if (!position || !map) return;

        google?.maps?.importLibrary('streetView').then(({ OverlayView }) => {
            const buttonInstance = new (class Button extends OverlayView {
                onAdd() {
                    this.container = document.createElement('div');
                    this.container.classList.add('button-overlay');
                    this.container.style.position = 'absolute';
                    this.container.style.visibility = `hidden`;

                    this.root = createRoot(this.container);
                    this.root.render(
                        <Stack direction="row" spacing={1}>
                            <Chip label={label} onClick={onClick} onDelete={onClick} color={color} />
                        </Stack>
                    );

                    this.getPanes()?.floatPane?.appendChild(this.container);

                    // Wait for overlay projection to initialize (typically 1-3 frames) before positioning the button
                    const checkProjection = () => {
                        if (this.getProjection()) {
                            this.draw();
                        } else {
                            requestAnimationFrame(checkProjection);
                        }
                    };
                    requestAnimationFrame(checkProjection);
                }

                onRemove() {
                    if (this.container?.parentElement) {
                        this.container.parentElement.removeChild(this.container);
                    }
                }

                draw() {
                    if (!this.container) return;
                    const projection = this.getProjection();
                    const divPosition = projection.fromLatLngToDivPixel(position);

                    if (this.container?.firstChild?.firstChild) {
                        const muiChip = this.container.firstChild.firstChild.getBoundingClientRect();
                        const offsetX = muiChip.width / 2;
                        const offsetY = muiChip.height / 2;

                        const { x, y } = getPixelPosition(divPosition, offsetX, offsetY);
                        this.container.style.top = `${y}px`;
                        this.container.style.left = `${x}px`;
                        this.container.style.width = 'unset';
                        this.container.style.visibility = `visible`;
                    }
                }
            })();

            instance.current = buttonInstance;
            instance.current.setMap(map);
        });

        return () => {
            instance.current?.setMap(null);
            instance.current = null;
        };
    }, []);

    return <></>;
};
export default MapDeleteButtonOverlay;